// Business details — update these placeholders with the real details when available.
export const BUSINESS = {
  name: "Zum Flooring",
  slogan: "Quality Floors. Lasting Impressions.",
  serviceArea: "Melbourne and surrounding suburbs",
  phoneDisplay: "0423 873 531",
  phoneTel: "tel:+61423873531",
  whatsappUrl: "https://wa.me/61423873531",
  email: "zumfloors@gmail.com",
  instagramUrl: "https://www.instagram.com/zumfloors",
  facebookUrl: "https://www.facebook.com/share/199gzUi2uj/?mibextid=wwXIfr",
  hours: [
    { days: "Monday – Friday", time: "8:00am – 5:00pm" },
    { days: "Saturday", time: "8:00am – 2:00pm" },
    { days: "Sunday", time: "Closed" },
  ],
  offer: "7 mm Hybrid Flooring – Supply & Installation from $39.50 per m²",
  supplyOnlyPrice: "$22.50 per m²",
};

export const PRODUCT_FEATURES = [
  "100% Waterproof",
  "Scratch Resistant",
  "Wear Resistant",
  "Fire Resistant",
  "Slip Resistant",
  "Deep Embossing Textured Surface",
];

export const SCOTIA_COLOURS = [
  "Coastal Oak", "Natural Oak", "Cloud Oak", "Blackbutt", "Blonde Oak",
  "Sand Oak", "Classic Oak", "Amber Oak", "Chestnut Oak", "Silver Oak",
];

export const TRIMS = [
  {
    name: "L-Trim",
    code: "7 mm",
    type: "Edge trim",
    image: "/api/files/zum-flooring/accessories/trim-l-trim-7mm.jpg",
    use: "Finishes the exposed edge of your 7 mm hybrid boards — at sliding doors, in front of fireplaces, or where the floor stops against tiles, carpet or a doorway without a step.",
    finishes: "silver, black, bronze and timber-look",
  },
  {
    name: "Corner Angle",
    code: "18-A",
    type: "Step & corner",
    image: "/api/files/zum-flooring/accessories/trim-corner-angle-18a.jpg",
    use: "Wraps and protects the board edge on step-downs, sunken living areas and stair nosings, so the exposed corner is covered and safe underfoot.",
    finishes: "silver, black, bronze and timber-look",
  },
  {
    name: "T-Cover",
    code: "38-T",
    type: "Transition",
    image: "/api/files/zum-flooring/accessories/trim-t-cover-38t.jpg",
    use: "Bridges two floors at the same height and covers the expansion gap between rooms or across long runs, with a wide 38 mm face.",
    finishes: "silver, black, bronze and timber-look",
  },
  {
    name: "T-Cover",
    code: "28-T",
    type: "Transition",
    image: "/api/files/zum-flooring/accessories/trim-t-cover-28t.jpg",
    use: "A slimmer 28 mm transition for doorways and narrower joins — same job as the 38-T with a lower-profile face for a more discreet finish.",
    finishes: "silver, black, bronze and timber-look",
  },
];

export const SCOTIA_IMAGE = "/api/files/zum-flooring/accessories/scotia-range.jpg";

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
